import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class Addon
 * @property {number} id
 * @property {Property} property
 * @property {string} name
 */
export class Addon extends TranslatableModel {
    
    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name' ];
    }
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'ADDON_NAME_IN_ENGLISH',
                commonLabel: 'Addon name'
            },
            name_ar: {
                label: 'ADDON_NAME_IN_ARABIC',
                commonLabel: 'Addon name'
            }
        };
    }
}

AccessorsMutatorsDecorator('id', ...Addon.translatableAttributesWithLanguageAliases, 'property', 'property_id', 'item', 'item_id', 'status', 'charge_type', 'charge_children', 'different_price_for_children',
    'transaction_code', 'show_when', 'post_transaction', 'images', 'max_sellable_quantity', 'transaction_action', 'order', 'intervals')(Addon);


// WEBPACK FOOTER //
// ./src/pms-api/models/addon.model.js